/**
 * @description 路由信息
 */

export default [
    {
        name: "firstIndex",
        path: "/",
        redirect: '/property',
        component: () => import("@/views/propertyManagement"),
        meta: {
            name: "物业管理中心"
        },
        children: [
            {
                name: "propertyPage",
                path: "/property",
                component: () => import("@/views/propertyManagement/pages/propertyPage"),
                meta: {
                    name: "物业管理中心详情"
                },
            },
            {
                name: "first",
                path: "/monitoring",
                component: () => import("@/views/propertyManagement/pages/firstPage"),
                meta: {
                    name: "监控中心"
                }
            },
            {
                name: "second",
                path: "/environment",
                component: () => import("@/views/propertyManagement/pages/secondPage"),
                meta: {
                    name: "环境监测"
                }
            },
            {
                name: "third",
                path: "/energy",
                component: () => import("@/views/propertyManagement/pages/thirdPage"),
                meta: {
                    name: "能耗管理"
                },
                children: [
                    {
                        name: "third-first",
                        path: "/waterCons",
                        component: () => import("@/views/propertyManagement/pages/thirdPage/pages/water-cons"),
                        meta: {
                            name: "能耗管理-水能耗"
                        },
                    },
                    {
                        name: "third-second",
                        path: "/gasCons",
                        component: () => import("@/views/propertyManagement/pages/thirdPage/pages/gas-cons"),
                        meta: {
                            name: "能耗管理-气能耗"
                        },
                    },
                    {
                        name: "third-third",
                        path: "/eleCons",
                        component: () => import("@/views/propertyManagement/pages/thirdPage/pages/ele-cons"),
                        meta: {
                            name: "能耗管理-电能耗（总）"
                        },
                    },
                    {
                        name: "third-fourth",
                        path: "/illuminaEle",
                        component: () => import("@/views/propertyManagement/pages/thirdPage/pages/illumina-ele"),
                        meta: {
                            name: "能耗管理-照明电"
                        },
                    },
                    {
                        name: "third-fifth",
                        path: "/powerEle",
                        component: () => import("@/views/propertyManagement/pages/thirdPage/pages/power-ele"),
                        meta: {
                            name: "能耗管理-动力电"
                        },
                    },
                    {
                        name: "third-sixth",
                        path: "/airEle",
                        component: () => import("@/views/propertyManagement/pages/thirdPage/pages/air-ele"),
                        meta: {
                            name: "能耗管理-空调电"
                        },
                    },
                ]
            },
            {
                name: "fourth",
                path: "/facility",
                component: () => import("@/views/propertyManagement/pages/fourthPage"),
                meta: {
                    name: "设备运维"
                },
                children: [
                    {
                        name: "fourth-first",
                        path: "/eletransfrom",
                        component: () => import("@/views/propertyManagement/pages/fourthPage/pages/ele-transfrom"),
                        meta: {
                            name: "设备运维-变配电"
                        },
                    },
                    {
                        name: "fourth-second",
                        path: "/watersupply",
                        component: () => import("@/views/propertyManagement/pages/fourthPage/pages/water-supply"),
                        meta: {
                            name: "设备运维-给排水"
                        },
                    },
                    {
                        name: "fourth-third",
                        path: "/equillumina",
                        component: () => import("@/views/propertyManagement/pages/fourthPage/pages/equ-illumina"),
                        meta: {
                            name: "设备运维-照明"
                        },
                    },
                    {
                        name: "fourth-fourth",
                        path: "/firecontrol/:id",
                        component: () => import("@/views/propertyManagement/pages/fourthPage/pages/fire-control"),
                        meta: {
                            name: "设备运维-消防"
                        },
                    },
                    {
                        name: "fourth-fifth",
                        path: "/security",
                        component: () => import("@/views/propertyManagement/pages/fourthPage/pages/security-protection"),
                        meta: {
                            name: "设备运维-安防"
                        },
                    },
                    {
                        name: "fourth-sixth",
                        path: "/aircondition",
                        component: () => import("@/views/propertyManagement/pages/fourthPage/pages/air-condition"),
                        meta: {
                            name: "设备运维-空调"
                        },
                    },
                    {
                        name: "fourth-seventh",
                        path: "/equelevator",
                        component: () => import("@/views/propertyManagement/pages/fourthPage/pages/equ-elevator"),
                        meta: {
                            name: "设备运维-电梯"
                        },
                    },
                    {
                        name: "fourth-eighth",
                        path: "/gateway",
                        component: () => import("@/views/propertyManagement/pages/fourthPage/pages/gateway"),
                        meta: {
                            name: "设备运维-网关"
                        },
                    },
                ]
            },
            {
                name: "fifth",
                path: "/park",
                component: () => import("@/views/propertyManagement/pages/fifthPage"),
                meta: {
                    name: "停车管理"
                }
            },
            {
                name: "sixth",
                path: "/keepwatch",
                component: () => import("@/views/propertyManagement/pages/sixthPage"),
                meta: {
                    name: "巡更管理"
                }
            },
            {
                name: "seventh",
                path: "/porinform",
                component: () => import("@/views/propertyManagement/pages/seventhPage"),
                meta: {
                    name: "物业通知"
                }
            },
            {
                name: "eighth",
                path: "/visitor",
                component: () => import("@/views/propertyManagement/pages/eighthPage"),
                meta: {
                    name: "访客管理"
                }
            },
            {
                name: "ninth",
                path: "/pay",
                component: () => import("@/views/propertyManagement/pages/ninthPage"),
                meta: {
                    name: "在线缴费"
                }
            },
            {
                name: "tenth",
                path: "/warin",
                component: () => import("@/views/propertyManagement/pages/tenthPage"),
                meta: {
                    name: "告警中心"
                }
            },
        ]
    },
    {
        name: "test",
        path: "/test",
        component: () => import("@/views/test")
    },
]
